import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  AddActionCallbackInput,
  AddActionDialog,
  AddActionDialogUniqueProps,
} from '../AddActionDialog';

const { useDialogForContext, useDialog: useAddActionDialog } = getDialogHooks<
  AddActionDialogUniqueProps,
  AddActionCallbackInput
>(AddActionDialog);
export const useAddActionDialogForContenxt = useDialogForContext;
export default useAddActionDialog;
